import React from 'react';

import FormalizingCard from '../components/FormalizingCard';

const FormalizingCardPage = () => {
  return <FormalizingCard />;
};

export default FormalizingCardPage;
